/*

Poornima 09/19/2022 2700799562 Fixed GAL-127,132,73,60,104 bugs
Sohel  09/30/2022 2700799562 Added Copy Functionality(GAL-311) and Tabel Payload Changes.
Ashraf 10/18/2022 2700799562 global field, group, field list UI changes
Ashraf 01/11/2022 2700799562 conditional renders for audit list

*/

import React from 'react';
import AddFieldListForm from './AddFieldListForm';

const AddFieldList = ({AuditFieldList, setTabValue, rowSelected, isCopyData, StepperFieldList, setShowSearch, handleChange, fieldList, setFieldList}) => {
  return (
    <>
      <AddFieldListForm
        StepperFieldList={StepperFieldList}
        setTabValue={setTabValue}
        rowSelected={rowSelected}
        isCopyData={isCopyData}
        setShowSearch={setShowSearch}
        handleTabChange={handleChange}
        globalFieldList={fieldList}
        setGlobalFieldList={setFieldList}
        AuditFieldList={AuditFieldList}
      />
    </>
  );
};

export default AddFieldList;
